import { render, staticRenderFns } from "./ModelerRouter.vue?vue&type=template&id=15ac4870&"
import script from "./ModelerRouter.vue?vue&type=script&lang=js&"
export * from "./ModelerRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports